import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

import { IPosition } from '../../enclosure/models/grid.model';

@Directive({
    selector: '[appKeyBoard]',
    standalone: false
})
export class KeyBoardDirective {
  mousePosition: IPosition;

  @Output() ctrlV = new EventEmitter();
  @Output() ctrlC = new EventEmitter<IPosition>();
  @Output() ctrlH = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() esc = new EventEmitter();
  @Output() zoomInWheel = new EventEmitter();
  @Output() zoomOutWheel = new EventEmitter();
  @Output() resetZoom = new EventEmitter();

  @HostListener('document:keydown.control.v', ['$event'])
  onCtrlV(event) {
    if (this.shouldForbidBehavior(event)) {
      return;
    }

    this.ctrlV.emit();
  }

  @HostListener('document:keydown.control.c', ['$event'])
  onCtrlC(event) {
    if (this.shouldForbidBehavior(event)) {
      return;
    }

    this.ctrlC.emit(this.mousePosition);
  }

  @HostListener('document:keydown.control.h', ['$event'])
  onCtrlH(event) {
    event.preventDefault();

    this.ctrlH.emit();
  }

  @HostListener('document:keydown.control.0', ['$event'])
  onResetZoom(event) {
    event.preventDefault();

    this.resetZoom.emit();
  }

  @HostListener('document:keydown.Delete', ['$event'])
  onDelete(event) {
    if (this.shouldForbidBehavior(event)) {
      return;
    }

    event.preventDefault();
    this.delete.emit();
  }

  @HostListener('document:keydown.Esc', ['$event'])
  onEsc(event) {
    if (this.shouldForbidBehavior(event)) {
      return;
    }

    event.preventDefault();
    this.esc.emit();
  }

  @HostListener('mousewheel', ['$event'])
  onMousewheel(event) {
    if (!event.ctrlKey) {
      return;
    }

    event.preventDefault();

    if (event.wheelDelta > 0) {
      this.zoomInWheel.emit();
    }
    if (event.wheelDelta < 0) {
      this.zoomOutWheel.emit();
    }
  }

  @HostListener('mousemove', ['$event'])
  onMouseOver(event: MouseEvent) {
    this.mousePosition = {
      top: event.clientY, left: event.clientX
    };
  }

  private shouldForbidBehavior(event): boolean {
    return ['INPUT', 'TEXTAREA'].indexOf(event?.target?.nodeName.toString()) >= 0;
  }
}
